import randomstring from 'randomstring';
import {
  getRequest,
  postRequest,
  patchRequest,
  uploadEncodedFile,
  deleteRequest
} from '../../Common/network-call';
import {
  INSTANCE_URL,
  FILES_URL,
  FILES_LOCAL_URL
} from '../../Common/constant';

export const UPDATE_SPEAKERS_FILES = 'UPDATE_SPEAKERS_FILES';
export const SPEAKER_FILES_CHANGED = 'SPEAKER_FILES_CHANGED';
export const WORKING_DYNAMIC_FORM = 'WORKING_DYNAMIC_FORM';
export const FETCH_ALL_PRODUCT_CATEGORY = 'FETCH_ALL_PRODUCT_CATEGORY';
export const FETCH_ALL_PRODUCT_SUB_CATEGORY = 'FETCH_ALL_PRODUCT_SUB_CATEGORY';

export const fetchProductAllCategory = (session, callback) => {
  let eventFilter = encodeURI(`((eventid=${session.eventid})AND(isactive=1))`);
  let masterFilter = encodeURI(`((eventid IS NULL)AND(isactive=1))`);

  let fetchUrl = `${INSTANCE_URL}/api/v2/eventify/_table/master_category?fields=id,name&include_count=true&order=createdon%20DESC`;

  return dispatch => {
    getRequest(
      `${fetchUrl}&filter=${eventFilter}`,
      session,
      dispatch,
      eventBasedData => {
        let responseData = eventBasedData;

        if (_.isEmpty(responseData?.resource) || !responseData?.meta?.count) {
          getRequest(
            `${fetchUrl}&filter=${masterFilter}`,
            session,
            dispatch,
            masterData => {
              responseData = masterData;

              dispatch({
                type: FETCH_ALL_PRODUCT_CATEGORY,
                payload: {
                  data: responseData?.resource,
                  count: responseData?.meta?.count
                }
              });
              callback({
                success: 1,
                data: responseData?.resource,
                count: responseData?.meta?.count
              });
            },
            error => {}
          );
        } else {
          dispatch({
            type: FETCH_ALL_PRODUCT_CATEGORY,
            payload: {
              data: responseData?.resource,
              count: responseData?.meta?.count
            }
          });
          callback({
            success: 1,
            data: responseData?.resource,
            count: responseData?.meta?.count
          });
        }
      },
      error => {}
    );
  };
};

export const fetchProductAllSubCategory = (session, callback) => {
  let eventFilter = encodeURI(`((eventid=${session.eventid})AND(isactive=1))`);
  let masterFilter = encodeURI(`((eventid IS NULL)AND(isactive=1))`);

  let fetchUrl = `${INSTANCE_URL}/api/v2/eventify/_table/master_subcategory?fields=id,categoryid,name&include_count=true&order=createdon%20DESC`;

  return dispatch => {
    getRequest(
      `${fetchUrl}&filter=${eventFilter}`,
      session,
      dispatch,
      eventBasedData => {
        let responseData = eventBasedData;

        if (_.isEmpty(responseData?.resource) || !responseData?.meta?.count) {
          getRequest(
            `${fetchUrl}&filter=${masterFilter}`,
            session,
            dispatch,
            masterData => {
              responseData = masterData;

              dispatch({
                type: FETCH_ALL_PRODUCT_SUB_CATEGORY,
                payload: {
                  data: responseData?.resource,
                  count: responseData?.meta?.count
                }
              });
              callback({
                success: 1,
                data: responseData?.resource,
                count: responseData?.meta?.count
              });
            },
            error => {}
          );
        } else {
          dispatch({
            type: FETCH_ALL_PRODUCT_SUB_CATEGORY,
            payload: {
              data: responseData?.resource,
              count: responseData?.meta?.count
            }
          });
          callback({
            success: 1,
            data: responseData?.resource,
            count: responseData?.meta?.count
          });
        }
      },
      error => {}
    );
  };
};

export const saveAppUser = (session, values, callback) => {
  let profileImage = values.profileimagehidden ? values.profileimagehidden : '';

  if (profileImage === 'removed') {
    values.profileurl = '';
  }

  // --- Local data hold and a flag value
  let interestByAppuser = values?.userinterests_by_appuserid
    ? values.userinterests_by_appuserid
    : [];

  // profile image S3 upload path
  let filename = `eventify/${
    session.eventid
  }/images/appusers/${randomstring.generate()}.jpg`;

  return dispatch => {
    // --- Profile image is getting uploaded
    _uploadImage(session, profileImage, filename, dispatch, profile => {
      if (profile.success) {
        // --- Assigning profile image path into appUser value
        values = {
          ...values,
          eventid: session.eventid,
          ...(profile.data && profile.data.path
            ? {
                profileurl: profile.data.path
              }
            : {})
        };

        // --- Image upload flag
        let isImageUpload = profile.data && profile.data.path ? true : false;

        dispatch(
          createUpdateAppuser(
            session,
            values,
            isImageUpload,
            interestByAppuser,
            res => {
              if (res.success) {
                callback({ success: 1 });
              }
            }
          )
        );
      } else {
        callback({ success: 2, data: profile.message });
      }
    });
  };
};

const gamePointForProfileUpload = (session, appuserid, callback) => {
  let challangeUrl = `${INSTANCE_URL}/api/v2/gamification_script/challenge_status`,
    challangeBody = {
      eventid: `${session.eventid}`,
      userid: appuserid,
      challengetype: 'completeprofile',
      type: 'uploadimage'
    };

  return dispatch => {
    postRequest(
      challangeUrl,
      challangeBody,
      session,
      dispatch,
      feedback => {
        let uploadPoints =
          feedback.resource && feedback.resource.points
            ? feedback.resource.points
            : 0;
        let points = parseInt(uploadPoints);

        if (feedback.resource && feedback.resource.points) {
          feedback.resource.points = points;
        }

        callback({
          success: 1,
          data: feedback.resource
        });
      },
      error => {
        callback({
          success: 0,
          message: error
        });
      }
    );
  };
};

export const createUpdateAppuser = (
  session,
  values,
  isImageUpload,
  interestByAppuser,
  callback
) => {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser`,
    localBody = values;

  delete localBody['userinterests_by_appuserid'];

  let game_imageUpload_response = {};

  let appUserPatchBody = { resource: localBody };
  return dispatch => {
    if (values.appuserid) {
      patchRequest(
        url,
        appUserPatchBody,
        session,
        dispatch,
        updateResponse => {
          // --- Assigning gamification points if profile changed (wheather to assign or not is checked in the backend gamification script)
          if (isImageUpload) {
            dispatch(
              gamePointForProfileUpload(session, values.appuserid, res => {
                game_imageUpload_response = res;
              })
            );
          }

          // --- Processing interest selection and associated gamification point assigning
          values.userinterests_by_appuserid = interestByAppuser;
          if (
            values?.userinterests_by_appuserid.length > 0 ||
            values?.userinterests.length > 0
          ) {
            dispatch(
              updateUserInterest(session, localBody, isImageUpload, res => {
                if (res.success) {
                  callback({
                    success: 1,
                    data: updateResponse,
                    interest: res,
                    game_imageupload: game_imageUpload_response
                  });
                }
              })
            );
          } else
            callback({
              success: 1,
              data: updateResponse,
              interest: null,
              game_imageupload: game_imageUpload_response
            });
        },
        error => {
          callback({ success: 0, message: error });
        }
      );
    } else {
      postRequest(
        url,
        body,
        session,
        dispatch,
        createResponse => {
          values.appuserid = data.resource[0].appuserid;

          // --- Assigning gamification points if profile changed (wheather to assign or not is checked in the backend gamification script)
          if (isImageUpload) {
            dispatch(
              gamePointForProfileUpload(session, values.appuserid, res => {
                game_imageUpload_response = res;
              })
            );
          }

          // --- Processing interest selection and associated gamification point assigning
          values.userinterests_by_appuserid = interestByAppuser;
          dispatch(
            updateUserInterest(session, localBody, isImageUpload, res => {
              if (res.success) {
                callback({
                  success: 1,
                  data: createResponse,
                  interest: res,
                  game_imageupload: game_imageUpload_response
                });
              }
            })
          );
        },
        error => {
          callback({ success: 0, message: error });
        }
      );
    }
  };
};

export const updateUserInterest = (
  session,
  values,
  isImageUpload,
  callback
) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(appuserid=${values.appuserid})`
  );
  let deleteUrl = `${INSTANCE_URL}/api/v2/eventify/_table/userinterests?filter=(${filter})`;
  let insertUrl = `${INSTANCE_URL}/api/v2/eventify/_table/userinterests`;

  let interests = [];
  values.userinterests.map(item => {
    interests.push({
      eventid: session.eventid,
      appuserid: values.appuserid,
      interestid: item
    });
  });
  let body = { resource: interests };

  if (values?.userinterests_by_appuserid.length > 0) {
    return dispatch => {
      deleteRequest(
        deleteUrl,
        session,
        dispatch,
        delres => {
          if (body.resource.length > 0) {
            postRequest(
              insertUrl,
              body,
              session,
              dispatch,
              response => {
                let challangeUrl = `${INSTANCE_URL}/api/v2/gamification_script/challenge_status`;
                let challangeBody = {
                  eventid: `${session.eventid}`,
                  userid: values.appuserid,
                  challengetype: 'completeprofile'
                };
                challangeBody.type = 'addinterest';
                postRequest(
                  challangeUrl,
                  challangeBody,
                  session,
                  dispatch,
                  gamResponse => {
                    callback({
                      success: 1,
                      challangesuccess: 1,
                      data: gamResponse.resource
                    });
                  },
                  error => {
                    callback({
                      success: 1,
                      challangesuccess: 0,
                      message: error
                    });
                  }
                );
              },
              error => {
                callback({ success: 0, message: error });
              }
            );
          } else {
            callback({ success: 1, challangesuccess: 0 });
          }
        },
        error => {
          callback({ success: 0, message: error });
        }
      );
    };
  } else if (interests.length > 0) {
    return dispatch => {
      postRequest(
        insertUrl,
        body,
        session,
        dispatch,
        response => {
          let challangeUrl = `${INSTANCE_URL}/api/v2/gamification_script/challenge_status`;
          let challangeBody = {
            eventid: `${session.eventid}`,
            userid: values.appuserid,
            challengetype: 'completeprofile'
          };
          challangeBody.type = 'addinterest';
          postRequest(
            challangeUrl,
            challangeBody,
            session,
            dispatch,
            gamResponse => {
              callback({
                success: 1,
                challangesuccess: 1,
                data: gamResponse.resource
              });
            },
            error => {
              callback({ success: 1, challangesuccess: 0, message: error });
            }
          );
          callback({ success: 1 });
        },
        error => {
          callback({ success: 0, message: error });
        }
      );
    };
  }
};

export function updateSpeakersFiles(file) {
  return dispatch => {
    dispatch({ type: UPDATE_SPEAKERS_FILES, payload: file });
  };
}

export function speakerAttachmentChanged(bool) {
  return dispatch => {
    dispatch({ type: SPEAKER_FILES_CHANGED, payload: bool });
  };
}

export function saveSpeaker(
  session,
  values,
  uploadFiles,
  filechanged,
  callback
) {
  let profileImage = values.profileimagehidden ? values.profileimagehidden : '';
  let filename = `eventify/${
    session.eventid
  }/images/speakers/${randomstring.generate()}.jpg`;
  // console.log('filechanged :- ', filechanged);
  // console.log('uploadFiles :- ', uploadFiles);
  // console.log(
  //   "profileImage.search(';base64,') :- ",
  //   profileImage.search(';base64,')
  // );

  if (profileImage === 'removed') {
    values.profileimage = '';
    values.profilethumbimage = '';
  }

  return dispatch => {
    if (profileImage.search(';base64,') > 0 && filechanged == true) {
      // console.log('Both..........');
      _uploadProfile(session, profileImage, filename, dispatch, profile => {
        if (profile.success) {
          _uploadAttachedFiles(session, uploadFiles, dispatch, attachments => {
            values = {
              ...values,
              profileimage: profile.data.path,
              profilethumbimage: profile.data.path,
              file1: attachments[0].file,
              file2: attachments[1].file,
              file3: attachments[2].file,
              file4: attachments[3].file,
              file5: attachments[4].file,
              eventid: session.eventid
            };
            dispatch(createUpdateSpeaker(session, values, callback));
          });
        } else {
          callback({ error: 2, data: profile.data.message });
        }
      });
    } else if (profileImage.search(';base64,') > 0 && filechanged == false) {
      // console.log('Profile image..........');
      _uploadProfile(session, profileImage, filename, dispatch, profile => {
        if (profile.success) {
          values = {
            ...values,
            profileimage: profile.data.path,
            profilethumbimage: profile.data.path,
            eventid: session.eventid
          };
          dispatch(createUpdateSpeaker(session, values, callback));
        } else {
          callback({ success: 2, data: profile.message });
        }
      });
    } else if (profileImage.search(';base64,') < 0 && filechanged == true) {
      // console.log('Attachments..........');
      _uploadAttachedFiles(session, uploadFiles, dispatch, attachments => {
        values = {
          ...values,
          file1: attachments[0].file,
          file2: attachments[1].file,
          file3: attachments[2].file,
          file4: attachments[3].file,
          file5: attachments[4].file,
          eventid: session.eventid
        };
        dispatch(createUpdateSpeaker(session, values, callback));
      });
    } else {
      // console.log('Only data..........');
      values = { ...values, eventid: session.eventid };
      dispatch(createUpdateSpeaker(session, values, callback));
    }
  };
}

export function createUpdateSpeaker(session, values, callback) {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/speaker`;
  let body = { resource: values };

  return dispatch => {
    if (values.speakerid) {
      patchRequest(
        url,
        body,
        session,
        dispatch,
        data => {
          callback({ success: 1, response: data });
        },
        error => {
          callback({ success: 0, message: error });
        }
      );
    } else {
      postRequest(
        url,
        body,
        session,
        dispatch,
        data => {
          callback({ success: 1, response: data });
        },
        error => {
          callback({ success: 0, message: error });
        }
      );
    }
  };
}

export function updateWorkingForm(data) {
  return dispatch => {
    dispatch({ type: WORKING_DYNAMIC_FORM, payload: data });
  };
}

export function saveSponsor(
  session,
  values,
  isdynamicFileChanged,
  workingDynamicForm,
  callback
) {
  let profileImage = values.logoimagehidden ? values.logoimagehidden : '';
  let bannerImage = values.bannerimagehidden ? values.bannerimagehidden : '';
  let logofilename = `eventify/${
    session.eventid
  }/images/sponsors/${randomstring.generate()}.png`;
  let bannerfilename = `eventify/${
    session.eventid
  }/images/sponsors/banner/${randomstring.generate()}.png`;

  if (profileImage === 'removed') {
    values.logoimgpath = '';
    values.logothumbimgpath = '';
  }
  if (bannerImage === 'removed') {
    values.bannerimage = '';
  }

  // // Remove blank values from all file fields fileArray
  // if (workingDynamicForm && workingDynamicForm.form) {
  //   _.map(workingDynamicForm.form, obj => {
  //     if (obj.key === 'file' && obj.fileArray && obj.fileArray.length > 0) {
  //       let newFileArray = _.filter(obj.fileArray, o => {
  //         return o != '';
  //       });
  //       obj.fileArray = newFileArray;
  //     }
  //   });
  // }

  // Fetch only files field
  let otherFilesData = _.filter(workingDynamicForm.form, file => {
    return file.key === 'file';
  });

  // Fetch dynamic field responses
  let responsesArray = JSON.parse(values.responses);

  // console.log('submit values:- ', values);
  // debugger;
  return dispatch => {
    _uploadImage(session, profileImage, logofilename, dispatch, profile => {
      if (profile.success) {
        _uploadImage(session, bannerImage, bannerfilename, dispatch, banner => {
          if (banner.success) {
            _uploadDynamicFormsFiles(
              session,
              otherFilesData,
              isdynamicFileChanged,
              'sponsors',
              dispatch,
              filesArray => {
                if (isdynamicFileChanged == true) {
                  _.map(filesArray, obj => {
                    let check = _.filter(responsesArray, function(file) {
                      return file.name === obj.name;
                    });
                    check[0].value = obj.fileArray;
                  });
                }

                values = {
                  ...values,
                  eventid: session.eventid,
                  ...(profile.data && profile.data.path
                    ? {
                        logoimgpath: profile.data.path,
                        logothumbimgpath: profile.data.path
                      }
                    : {}),
                  ...(banner.data && banner.data.path
                    ? {
                        bannerimage: banner.data.path
                      }
                    : {}),
                  responses: JSON.stringify(responsesArray)
                };
                // console.log('final values:- ', values);
                // debugger;
                dispatch(createUpdateSponsor(session, values, callback));
              }
            );
          } else {
            callback({ error: 2 });
          }
        });
      } else {
        callback({ error: 2 });
      }
    });
  };
}

export function createUpdateSponsor(session, values, callback) {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/sponsor`;
  let body = { resource: values };

  return dispatch => {
    if (values.sponsorid) {
      patchRequest(
        url,
        body,
        session,
        dispatch,
        data => {
          callback({ success: 1, response: data });
        },
        error => {
          callback({ success: 0, message: error });
        }
      );
    } else {
      postRequest(
        url,
        body,
        session,
        dispatch,
        data => {
          callback({ success: 1, response: data });
        },
        error => {
          callback({ success: 0, message: error });
        }
      );
    }
  };
}

export function saveExhibitor(
  session,
  values,
  isdynamicFileChanged,
  workingDynamicForm,
  callback
) {
  let profileImage = values.logoimagehidden ? values.logoimagehidden : '';
  let bannerImage = values.bannerimagehidden ? values.bannerimagehidden : '';
  let logofilename = `eventify/${
    session.eventid
  }/images/exhibitors/${randomstring.generate()}.png`;
  let bannerfilename = `eventify/${
    session.eventid
  }/images/exhibitors/banner/${randomstring.generate()}.png`;

  if (profileImage === 'removed') {
    values.profileimage = '';
    values.profilethumbimage = '';
  }
  if (bannerImage === 'removed') {
    values.bannerimage = '';
  }

  // // Remove blank values from all file fields fileArray
  // if (workingDynamicForm && workingDynamicForm.form) {
  //   _.map(workingDynamicForm.form, obj => {
  //     if (obj.key === 'file' && obj.fileArray && obj.fileArray.length > 0) {
  //       let newFileArray = _.filter(obj.fileArray, o => {
  //         return o != '';
  //       });
  //       obj.fileArray = newFileArray;
  //     }
  //   });
  // }

  // Fetch only files field
  let otherFilesData = _.filter(workingDynamicForm.form, file => {
    return file.key === 'file';
  });

  // Fetch dynamic field responses
  let responsesArray = JSON.parse(values.responses);

  // Remove blank group fields
  _.map(responsesArray, obj => {
    if (obj.key === 'group' && obj.value && obj.value.length > 0) {
      if (obj.type === 'products') {
        let newArray = _.filter(obj.value, o => {
          return (
            o.productimages != '' ||
            o.productcategory != '' ||
            o.productsubcategory != '' ||
            o.producttitle != '' ||
            o.productinfo != ''
          );
        });
        obj.value = newArray;
      } else if (obj.type === 'coupons') {
        let newArray = _.filter(obj.value, o => {
          return (
            o.coupontitle != '' ||
            o.couponabout != '' ||
            o.couponecode != '' ||
            o.couponvalidtill != ''
          );
        });
        obj.value = newArray;
      } else if (obj.type === 'deals') {
        let newArray = _.filter(obj.value, o => {
          return (
            o.dealtitle != '' || o.dealabout != '' || o.dealvalidtill != ''
          );
        });
        obj.value = newArray;
      }
    }
  });

  // Fetch only product group field data
  let groupProductData = _.filter(responsesArray, data => {
    return data.key === 'group' && data.type === 'products';
  });
  let groupProductValue =
    groupProductData.length > 0 ? groupProductData[0].value : [];

  // console.log('submit values:- ', values);
  // console.log('responsesArray :- ', responsesArray);
  // console.log('otherFilesData :- ', otherFilesData);
  // console.log('groupProductData :- ', groupProductData);
  // debugger;
  return dispatch => {
    _uploadImage(session, profileImage, logofilename, dispatch, profile => {
      if (profile.success) {
        _uploadImage(session, bannerImage, bannerfilename, dispatch, banner => {
          if (banner.success) {
            _uploadDynamicFormsFiles(
              session,
              otherFilesData,
              isdynamicFileChanged,
              'exhibitors',
              dispatch,
              filesArray => {
                _uploadGroupProductImage(
                  session,
                  groupProductValue,
                  dispatch,
                  product => {
                    // console.log('product :- ', product);
                    let check = _.filter(responsesArray, function(data) {
                      return data.key === 'group' && data.type === 'products';
                    });
                    if (check.length > 0) check[0].value = product;
                    // console.log('responsesArray :- ', responsesArray)

                    if (isdynamicFileChanged == true) {
                      _.map(filesArray, obj => {
                        let check = _.filter(responsesArray, function(file) {
                          return file.name === obj.name;
                        });
                        if (check.length > 0) check[0].value = obj.fileArray;
                      });
                    }

                    values = {
                      ...values,
                      eventid: session.eventid,
                      ...(profile.data && profile.data.path
                        ? {
                            profileimage: profile.data.path,
                            profilethumbimage: profile.data.path
                          }
                        : {}),
                      ...(banner.data && banner.data.path
                        ? {
                            bannerimage: banner.data.path
                          }
                        : {}),
                      responses: JSON.stringify(responsesArray)
                    };
                    // console.log('final values:- ', values);
                    // debugger;
                    // dispatch(createUpdateExhibitor(session, values, callback));
                    createUpdateExhibitor(
                      session,
                      values,
                      dispatch,
                      feedback => {
                        if (feedback.success) {
                          createUpdateExhibitorProducts(
                            session,
                            values,
                            feedback.exhibitorid,
                            dispatch,
                            prores => {
                              if (prores.success) {
                                callback({ success: 1 });
                              } else {
                                callback({ success: 4 });
                              }
                            }
                          );
                        } else {
                          callback({ success: 0, message: feedback.message });
                        }
                      }
                    );
                  }
                );
              }
            );
          } else {
            callback({ success: 3 });
          }
        });
      } else {
        callback({ success: 2 });
      }
    });
  };
}

export function createUpdateExhibitor(session, values, dispatch, callback) {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/exhibitors`;
  let body = { resource: values };

  if (values.exhibitorid) {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      data => {
        let exhibitorid = data.resource[0].exhibitorid;
        callback({ success: 1, exhibitorid: exhibitorid });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  } else {
    postRequest(
      url,
      body,
      session,
      dispatch,
      data => {
        let exhibitorid = data.resource[0].exhibitorid;
        callback({ success: 1, exhibitorid: exhibitorid });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  }
}

export function createUpdateExhibitorProducts(
  session,
  values,
  exhibitorid,
  dispatch,
  callback
) {
  // console.log("called.......");
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/exhibitor_products/`;
  let responsesArray = JSON.parse(values.responses);
  let groupProductData = _.filter(responsesArray, data => {
    return data.key === 'group' && data.type === 'products';
  });

  let data = [];
  if (groupProductData.length > 0) {
    _.map(groupProductData[0].value, (item, index) => {
      let obj = {
        exhibitorid: exhibitorid,
        eventid: session.eventid,
        title: item.producttitle,
        description: item.productinfo,
        category: item.productcategory,
        subcategory: item.productsubcategory,
        image: item.productimages
      };
      data.push(obj);
    });
  }
  let body = { resource: data };
  // console.log("responsesArray :- ", responsesArray);
  // console.log('groupProductData :- ', groupProductData);
  // console.log('body :- ', body.resource);

  if (values.exhibitorid) {
    let filter = encodeURI(
      `(exhibitorid=${values.exhibitorid})AND(eventid=${session.eventid})`
    );
    let deleteUrl = `${INSTANCE_URL}/api/v2/eventify/_table/exhibitor_products?filter=${filter}`;
    getRequest(
      deleteUrl,
      session,
      dispatch,
      res => {
        if (res.resource.length == 0) {
          callback({ success: 1 });
        } else {
          deleteRequest(
            deleteUrl,
            session,
            dispatch,
            delres => {
              if (body.resource.length > 0) {
                postRequest(
                  url,
                  body,
                  session,
                  dispatch,
                  data => {
                    callback({ success: 1 });
                  },
                  error => {
                    callback({ success: 0, message: error });
                  }
                );
              } else {
                callback({ success: 1 });
              }
            },
            error => {
              callback({ success: 0, message: error });
            }
          );
        }
      },
      error => {
        callback({ success: 0 });
      }
    );
  } else {
    if (body.resource.length > 0) {
      postRequest(
        url,
        body,
        session,
        dispatch,
        data => {
          callback({ success: 1 });
        },
        error => {
          callback({ success: 0, message: error });
        }
      );
    } else {
      callback({ success: 1 });
    }
  }
}

export function _uploadProfile(
  session,
  imagedata,
  filename,
  dispatch,
  callback
) {
  imagedata = imagedata.replace(/^data:image\/[a-z]+;base64,/, '');
  let imageJson = {
    resource: [
      {
        name: filename,
        type: 'file',
        is_base64: true,
        content: imagedata
      }
    ]
  };

  uploadEncodedFile(
    `${FILES_URL}?check_exist=false`,
    session,
    imageJson,
    dispatch,
    data => {
      callback({ success: 1, data: data });
    },
    error => {
      callback({ success: 0, message: error });
    }
  );
}

export function _uploadImage(session, imagedata, filename, dispatch, callback) {
  if (imagedata.search(';base64,') > 0) {
    imagedata = imagedata.replace(/^data:image\/[a-z]+;base64,/, '');
    let imageJson = {
      resource: [
        {
          name: filename,
          type: 'file',
          is_base64: true,
          content: imagedata
        }
      ]
    };

    uploadEncodedFile(
      `${FILES_URL}?check_exist=false`,
      session,
      imageJson,
      dispatch,
      data => {
        callback({ success: 1, data: data });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  } else {
    callback({ success: 1 });
  }
}

export function _uploadAttachedFiles(session, uploadFiles, dispatch, callback) {
  let promiseArray = [];
  _.map(uploadFiles, (item, index) => {
    promiseArray.push(
      new Promise((resolve, reject) => {
        // console.log('index :- ', index);
        // console.log('item :- ', item);
        let file = item.file ? item.file : '';
        let name = item.filename;
        let n = file.search(';base64,');
        if (n > 0) {
          let content = file.split(';base64,')[1];
          // let fileCustomName = name.substr(0, name.lastIndexOf('.'));
          // let fileType = name.split('.').pop();

          // ===== This code and flow is provided by Vinay Pathak
          // let removeSpace = fileData.name.replace(/ /g, "-");
          let removeSpace = name.replace(/ /g, '_'); // space replaced with -
          let split = removeSpace.split('.'); // replaced name split by . so [0]->name [1]->ext
          let ext = split.pop(); // [1]
          let newFname = split.join(); // again whole name
          // let  stringToReplace = 'a@A9 8_)*AÀń.'
          let newFnm = newFname.replace(/[^\w\s]/gi, '_'); // special character regex replace with _
          let fileName = newFnm + '.' + ext; // new file name

          // let filename = `eventify/files/speakers/${fileCustomName}_${randomstring.generate()}.${fileType}`;
          let filename = `eventify/${session.eventid}/files/speakers/${fileName}`;
          let imageJson = {
            resource: [
              {
                name: filename,
                type: 'file',
                is_base64: true,
                content: content
              }
            ]
          };
          uploadEncodedFile(
            `${FILES_URL}?check_exist=false`,
            session,
            imageJson,
            dispatch,
            data => {
              uploadFiles[index].file = data.name;
              resolve();
            },
            error => {
              // callback({success:2, message:error});
            }
          );
        } else if (file == '') {
          uploadFiles[index].file = null;
          resolve();
        } else {
          uploadFiles[index].file = file;
          resolve();
        }
      })
    );
    // console.log('upload... ', index)
  });
  // console.log('upload...', promiseArray)
  Promise.all(promiseArray).then(() => {
    // console.log('upload...callback')
    callback({ ...uploadFiles });
  });
}

export function _uploadDynamicFormsFiles(
  session,
  otherFilesData,
  isdynamicFileChanged,
  comesFrom,
  dispatch,
  callback
) {
  // uploadFiles

  if (isdynamicFileChanged == true) {
    let promiseArray = [];

    _.map(otherFilesData, (field, key) => {
      // Files field array
      let uploadFiles = field.fileArray;
      let fileCategory =
        field.name === 'galleryimages'
          ? 'galleryimages'
          : field.name === 'galleryvideos'
          ? 'galleryvideos'
          : field.name === 'documents'
          ? 'documents'
          : 'otherfiles';

      _.map(uploadFiles, (item, index) => {
        if (item) {
          promiseArray.push(
            new Promise((resolve, reject) => {
              let file = item.file;
              let name = item.filename;
              let n = file.search(';base64,');
              if (n > 0) {
                let content = file.split(';base64,')[1];
                // let fileCustomName = name.substr(0, name.lastIndexOf('.'));
                // let fileType = name.split('.').pop();
                // let rand_num = randomstring.generate();

                // // let onlyFileName = `${fileCustomName}_${randomstring.generate()}`;

                // if (fileCategory == 'galleryvideos') {
                //   fileCustomName = fileCustomName.replace(
                //     /[&\/\\#,+()$~%.'":*?<>{}\s]/g,
                //     '_'
                //   );
                // }

                // ===== This code and flow is provided by Vinay Pathak
                // let removeSpace = fileData.name.replace(/ /g, "-");
                let removeSpace = name.replace(/ /g, '_'); // space replaced with -
                let split = removeSpace.split('.'); // replaced name split by . so [0]->name [1]->ext
                let ext = split.pop(); // [1]
                let newFname = split.join(); // again whole name
                // let  stringToReplace = 'a@A9 8_)*AÀń.'
                let newFnm = newFname.replace(/[^\w\s]/gi, '_'); // special character regex replace with _
                let fileName = newFnm + '.' + ext; // new file name

                // let filename = `eventify/files/${comesFrom}/${fileCategory}/${onlyFileName}.${fileType}`;
                // let filename = `eventify/${session.eventid}/files/${comesFrom}/${fileCategory}/${fileCustomName}_${rand_num}.${fileType}`;

                let imageJson = {
                  resource: [
                    {
                      name: `eventify/${session.eventid}/files/${comesFrom}/${fileCategory}/${fileName}`,
                      type: 'file',
                      is_base64: true,
                      content: content
                    }
                  ]
                };

                // uploads file to aws server but for videos uploads to local [ file3 ]

                // uploadEncodedFile(
                //   `${
                //     fileCategory === 'galleryvideos'
                //       ? FILES_LOCAL_URL
                //       : FILES_URL
                //   }?check_exist=false`,
                uploadEncodedFile(
                  `${FILES_URL}?check_exist=false`,
                  session,
                  imageJson,
                  dispatch,
                  data => {
                    if (fileCategory == 'galleryvideos') {
                      let thumbJson = {
                        eventid: session.eventid,
                        filename: fileName,
                        foldername: `eventify/${session.eventid}/files/${comesFrom}/galleryvideos`,
                        subfoldername: `${comesFrom}/galleryvideos/`,
                        thumbname: `${fileName}.jpg`,
                        type: 'createThumbFromVideo'
                      };

                      dispatch(
                        _createVideoThumbnails(session, thumbJson, res => {
                          if (!res.success) {
                            callback(res);
                          }
                        })
                      );
                    }

                    uploadFiles[index] = data.name;
                    resolve();
                  },
                  error => {
                    // callback({success:2, message:error});
                  }
                );
              } else {
                uploadFiles[index] = file;
                resolve();
              }
            })
          );
          // console.log('upload... ', index)
        }
      });
      // console.log('uploadFiles...', uploadFiles)

      field.fileArray = uploadFiles;
    });

    // console.log('upload...', promiseArray)
    // console.log('otherFilesData...', otherFilesData)
    Promise.all(promiseArray).then(() => {
      // console.log('upload...callback')
      callback(otherFilesData);
    });
  } else {
    callback({ success: 1 });
  }
}

export function _uploadGroupProductImage(
  session,
  uploadFiles,
  dispatch,
  callback
) {
  let promiseArray = [];
  _.map(uploadFiles, (item, index) => {
    promiseArray.push(
      new Promise((resolve, reject) => {
        let file = item.productimages;
        let n = file.search(';base64,');
        if (n > 0) {
          let content = file.split(';base64,')[1];
          let filename = `eventify/${
            session.eventid
          }/files/exhibitors/productimages/${randomstring.generate()}.png`;
          let imageJson = {
            resource: [
              {
                name: filename,
                type: 'file',
                is_base64: true,
                content: content
              }
            ]
          };
          uploadEncodedFile(
            `${FILES_URL}?check_exist=false`,
            session,
            imageJson,
            dispatch,
            data => {
              uploadFiles[index].productimages = data.name;
              resolve();
            },
            error => {
              // callback({success:2, message:error});
            }
          );
        } else if (file == '') {
          uploadFiles[index].productimages = '';
          resolve();
        } else {
          uploadFiles[index].productimages = file;
          resolve();
        }
      })
    );
    // console.log('upload... ', index)
  });
  // console.log('upload...', promiseArray)
  Promise.all(promiseArray).then(() => {
    // console.log('upload...callback')
    callback(uploadFiles);
  });
}

export const _createVideoThumbnails = (session, postBody, callback) => {
  let url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;

  return dispatch => {
    postRequest(
      url,
      postBody,
      session,
      dispatch,
      res => {
        callback({ success: 1, data: res });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};
